<template>
    <input ref="inputElement" type="text" class="form-control" />
</template>

<script setup lang="ts">
    import { NumberInput, type NumberInputOptions } from "@/portal/formControls/NumberInput";
    import { onMounted, ref, watch } from "vue";

    const model = defineModel<number | undefined>({ required: true });
    const props = defineProps<{
        options?: NumberInputOptions;
    }>();

    const inputElement = ref<HTMLInputElement | null>(null);

    let numberInput: NumberInput | undefined;
    onMounted(() => {
        if (inputElement.value) {
            numberInput = new NumberInput($(inputElement.value), props.options);
            numberInput.setValue(model.value);
            numberInput.onChange = (value) => {
                if (props.options?.required === true) {
                    if (value == null){
                        value = props.options?.min ?? 0;
                    }
                }
                
                model.value = value;
            };
        }
    });

    watch(model, (value) => {
        if (numberInput) {
            numberInput.setValue(value);
        }
    });

    function setError(hasError: boolean) {
        numberInput?.setError(hasError);
    }

    defineExpose({
        setError,
    });
</script>
